// Scans the real, about-to-be-shown page for every <img> it actually rendered
// (Hero's bird/leaves/badge, product photos, testimonial avatars, footer logo, …)
// and waits for each to finish loading — instead of relying on a hand-maintained
// list that drifts out of sync as components change. `onEach` fires once per
// image (success or failure) so the caller can drive a progress indicator.
export const waitForImages = (root: HTMLElement | null, onEach?: () => void): Promise<void> => {
  if (!root) return Promise.resolve();
  const imgs = Array.from(root.querySelectorAll("img"));
  if (imgs.length === 0) return Promise.resolve();

  return Promise.all(
    imgs.map((img) => {
      if (img.complete && img.naturalWidth > 0) {
        onEach?.();
        return Promise.resolve();
      }
      return new Promise<void>((resolve) => {
        const done = () => {
          onEach?.();
          resolve();
        };
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
      });
    })
  ).then(() => undefined);
};
